import { __extends as e } from "./index50.mjs";
var c;
(function(r) {
  r.MISSING_VALUE = "MISSING_VALUE", r.INVALID_VALUE = "INVALID_VALUE", r.MISSING_INTL_API = "MISSING_INTL_API";
})(c || (c = {}));
var I = (
  /** @class */
  (function(r) {
    e(t, r);
    function t(o, n, a) {
      var i = r.call(this, o) || this;
      return i.code = n, i.originalMessage = a, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  })(Error)
), l = (
  /** @class */
  (function(r) {
    e(t, r);
    function t(o, n, a, i) {
      return r.call(this, 'Invalid values for "'.concat(o, '": "').concat(n, '". Options are "').concat(Object.keys(a).join('", "'), '"'), c.INVALID_VALUE, i) || this;
    }
    return t;
  })(I)
), s = (
  /** @class */
  (function(r) {
    e(t, r);
    function t(o, n, a) {
      return r.call(this, 'Value for "'.concat(o, '" must be of type ').concat(n), c.INVALID_VALUE, a) || this;
    }
    return t;
  })(I)
), V = (
  /** @class */
  (function(r) {
    e(t, r);
    function t(o, n) {
      return r.call(this, 'The intl string context variable "'.concat(o, '" was not provided to the string "').concat(n, '"'), c.MISSING_VALUE, n) || this;
    }
    return t;
  })(I)
);
export {
  c as ErrorCode,
  I as FormatError,
  l as InvalidValueError,
  s as InvalidValueTypeError,
  V as MissingValueError
};
